import React from 'react'

import { AsyncSelect } from '_zari/core'

import * as PresupuestoService from 'services/presupuesto.service'

const PresupuestoNivel3Select2 = ({ id, onChange }) => {
  const loadCentrosSelect = React.useCallback((inputValue, resolve) => {
    PresupuestoService.obtenerAsNivel3Select2({
      busqueda: inputValue
    })
      .then(({ data }) => resolve(data))
      .catch(() => resolve([]))
  }, [])

  return <AsyncSelect selectId={id} loadOptions={loadCentrosSelect} onChange={onChange} />
}

export default React.memo(PresupuestoNivel3Select2)
